import { useTranslation } from '@wix/fe-essentials/react';
import { ElementStatus, RuleElement } from '@wix/rules-panel-ui';
import React, { useCallback } from 'react';
import { BiCtaNames } from '../../../bi/types';
import { useBiLogger } from '../../../hooks/use-bi-logger';
import { useHandleElementClick } from '../../../hooks/use-handle-element-click';
import { convertBooleanStatusToElementStatus } from '../alt-image-fixer/utils';
import { InaccessibleComponentsElementContent } from './inaccessible-components-rule-content/inaccessible-components-element-content';
import { InaccessibleComponentsRuleHeader } from './inaccessible-components-rule-header';
export const InaccessibleComponentsRule = _ref => {
  let {
    isOpen,
    toggleElement,
    elementIndex,
    element,
    contentRef,
    headerRef,
    pageId
  } = _ref;
  const biLogger = useBiLogger();
  const {
    t
  } = useTranslation();
  const status = convertBooleanStatusToElementStatus(element.isFixed ?? false);
  const onStatusChange = useCallback(() => {
    biLogger.elementStatusChange({
      index: elementIndex,
      status: status ? ElementStatus.ManualPassed : ElementStatus.ManualFailed
    });
  }, [biLogger, elementIndex, status]);
  const {
    handleClickElement
  } = useHandleElementClick({
    isOpen,
    onOpenElement: () => biLogger.taskElementCtaClick({
      ctaName: BiCtaNames.Edit,
      index: elementIndex,
      status: status ? ElementStatus.ManualPassed : ElementStatus.ManualFailed
    }),
    toggleElement
  });
  return /*#__PURE__*/React.createElement(RuleElement, {
    contentComponent: /*#__PURE__*/React.createElement("div", {
      ref: contentRef
    }, /*#__PURE__*/React.createElement(InaccessibleComponentsElementContent, {
      element: element,
      elementIndex: elementIndex,
      pageId: pageId,
      status: status
    })),
    headerComponent: /*#__PURE__*/React.createElement("div", {
      ref: isOpen ? headerRef : null
    }, /*#__PURE__*/React.createElement(InaccessibleComponentsRuleHeader, {
      label: element.label ?? ''
    })),
    iconButtonAriaLabel: t('accessibility-wizard.common.edit.aria-label'),
    iconButtonToolTip: t('accessibility-wizard.common.edit'),
    id: element.id,
    isOpen: isOpen,
    status: status,
    onClick: handleClickElement,
    onStatusChange: onStatusChange
  });
};
//# sourceMappingURL=inaccessible-components-rule.js.map